import { render, staticRenderFns } from "./autorizacao-tiss.vue?vue&type=template&id=4b5f4225&"
import script from "./autorizacao-tiss.vue?vue&type=script&lang=js&"
export * from "./autorizacao-tiss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports